var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticStyle: { "padding-top": "1rem" },
      attrs: { id: "deliverable__in__project__list" }
    },
    [
      _c(
        "b-modal",
        {
          staticClass: "modal-edit-deliverable",
          attrs: {
            size: "xl",
            "hide-footer": "",
            id: "editDeliverableModal",
            title: ""
          },
          on: {
            hide: _vm.editDeliverableModalHidden,
            shown: _vm.pushRoute,
            hidden: _vm.removeRoute
          }
        },
        [
          _c("EditModal", {
            ref: "refEditModal",
            attrs: { allContacts: _vm.allContacts }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(_vm.projectDeliverables, function(deliverable, index) {
        return _c(
          "div",
          {
            key: "projectdeliverable-" + index,
            staticClass: "deliverable-block project-block",
            class: !_vm.userCanEditDeliverable(deliverable) ? "read-only" : "",
            attrs: { id: "project__deliverable__" + deliverable.id }
          },
          [
            _c(
              "div",
              { staticClass: "delv-block-resp" },
              [
                _c("DuplicateMediaCallFromProjectBtn", {
                  attrs: { deliverableId: deliverable.id }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "d-flex flex-row dbox-wrapper" }, [
                  _c(
                    "div",
                    { staticClass: "dbox-left-side dleft-inner-wrap" },
                    [
                      _c(
                        "div",
                        { staticClass: "top-row" },
                        [
                          !_vm.canChangeDeliverableType()
                            ? _c("div", { staticClass: "data-items" }, [
                                _c("span", [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.deliverableTypeTitle(
                                          deliverable.deliverable_template_id
                                        )
                                      ) +
                                      "\n\t\t\t\t\t\t\t"
                                  )
                                ])
                              ])
                            : _c(
                                "div",
                                {
                                  staticClass:
                                    "data-items deliverable-type-link",
                                  attrs: { "data-toggle": "dropdown" }
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.deliverableTypeTitle(
                                            deliverable.deliverable_template_id
                                          )
                                        ) +
                                        "\n                            "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "dropdown-menu" },
                                    _vm._l(_vm.deliverableTypes, function(
                                      type,
                                      i
                                    ) {
                                      return _c(
                                        "a",
                                        {
                                          key: i,
                                          staticClass: "dropdown-item",
                                          attrs: { href: "#" },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.changeDeliverableType(
                                                deliverable,
                                                type
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v(_vm._s(type.name))]
                                      )
                                    }),
                                    0
                                  )
                                ]
                              ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "data-items hide-mobile" },
                            [
                              _c("DeliverableProjects", {
                                attrs: { deliverable: deliverable }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.hasPriorityField(deliverable)
                            ? _c(
                                "div",
                                { staticClass: "data-items hide-mobile" },
                                [
                                  _c("span", {}, [_vm._v("PRIORITY: ")]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.hover",
                                          modifiers: { hover: true }
                                        }
                                      ],
                                      staticClass: "listing-priority",
                                      class:
                                        "listing-priority-del-" +
                                        deliverable.id,
                                      attrs: { title: "Priority" },
                                      on: {
                                        click: function($event) {
                                          return _vm.setPriority(deliverable)
                                        }
                                      }
                                    },
                                    [
                                      _c("vue-star-rate", {
                                        key:
                                          "del-rating-" +
                                          Math.random() +
                                          deliverable.id,
                                        attrs: {
                                          rateRange: deliverable.priority
                                            ? Number(deliverable.priority)
                                            : 0,
                                          maxIcon: 5,
                                          iconHeight: 17,
                                          iconWidth: 17,
                                          hasCounter: false,
                                          iconColor: "#4C9850",
                                          iconColorHover: "#4C9850",
                                          iconShape: "circle"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showAltStartEndDate(deliverable)
                            ? [
                                _vm._l(
                                  _vm._.filter(deliverable.customFields, {
                                    field_key: "start_date"
                                  }),
                                  function(field, index) {
                                    return _c(
                                      "div",
                                      {
                                        key: "prj-deliverable-" + Math.random(),
                                        staticClass: "data-items hide-mobile"
                                      },
                                      [
                                        _c("span", {}, [_vm._v("START DATE:")]),
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t" +
                                            _vm._s(
                                              _vm._f("moment")(
                                                field.value,
                                                "DD MMM, YYYY @ H:mm"
                                              )
                                            ) +
                                            "\n\t\t\t\t\t\t\t\t"
                                        )
                                      ]
                                    )
                                  }
                                ),
                                _vm._v(" "),
                                _vm._l(
                                  _vm._.filter(deliverable.customFields, {
                                    field_key: "end_date"
                                  }),
                                  function(field, index) {
                                    return _c(
                                      "div",
                                      {
                                        key: "prj-deliverable-" + Math.random(),
                                        staticClass: "data-items hide-mobile"
                                      },
                                      [
                                        _c("span", {}, [_vm._v("END DATE:")]),
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t" +
                                            _vm._s(
                                              _vm._f("moment")(
                                                field.value,
                                                "DD MMM, YYYY @ H:mm"
                                              )
                                            ) +
                                            "\n\t\t\t\t\t\t\t"
                                        )
                                      ]
                                    )
                                  }
                                ),
                                _vm._v(" "),
                                _vm._.filter(deliverable.customFields, {
                                  field_key: "start_date"
                                }).length == 0
                                  ? _c("div", { staticClass: "data-items" }, [
                                      _c("span", {}, [_vm._v("START DATE:")]),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\tNo Date\n\t\t\t\t\t\t\t"
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.calculateEndDate(deliverable)
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "data-items hide-mobile"
                                        },
                                        [
                                          _c("span", {}, [_vm._v("END DATE:")]),
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t" +
                                              _vm._s(
                                                _vm._f("moment")(
                                                  _vm.calculateEndDate(
                                                    deliverable
                                                  ),
                                                  "DD MMM, YYYY"
                                                )
                                              ) +
                                              "\n\t\t\t\t\t\t\t\t"
                                          )
                                        ]
                                      )
                                    ]
                                  : [_vm._m(0, true)]
                              ]
                            : [
                                _c("div", { staticClass: "data-items" }, [
                                  _c("span", { staticClass: "hide-mobile" }, [
                                    _vm._v("STARTED:")
                                  ]),
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm._f("moment")(
                                          deliverable.created_at,
                                          "DD MMM, YYYY @ H:mm"
                                        )
                                      ) +
                                      "\n                            "
                                  )
                                ]),
                                _vm._v(" "),
                                deliverable.all_completed
                                  ? _c("div", { staticClass: "data-items" }, [
                                      _c(
                                        "span",
                                        { staticClass: "hide-mobile" },
                                        [_vm._v("COMPLETED:")]
                                      ),
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm._f("moment")(
                                              deliverable.completed_at,
                                              "DD MMM, YYYY @ H:mm"
                                            )
                                          ) +
                                          "\n                            "
                                      )
                                    ])
                                  : _c("div", { staticClass: "data-items" }, [
                                      _c(
                                        "span",
                                        { staticClass: "hide-mobile" },
                                        [_vm._v("LAST MODIFIED:")]
                                      ),
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm._f("moment")(
                                              deliverable.updated_at,
                                              "DD MMM, YYYY @ H:mm"
                                            )
                                          ) +
                                          "\n                            "
                                      )
                                    ])
                              ]
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("DeliverableTypeIcon", {
                        attrs: {
                          deliverableTypeId: deliverable.deliverable_template_id
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "row mobile-deli-info" },
                        [
                          _vm.hasPriorityField(deliverable)
                            ? _c(
                                "div",
                                {
                                  staticClass: "data-items deliverable-priority"
                                },
                                [
                                  _c("span", { staticClass: "text-primary" }, [
                                    _vm._v("PRIORITY: ")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.hover",
                                          modifiers: { hover: true }
                                        }
                                      ],
                                      staticClass: "listing-priority",
                                      class:
                                        "listing-priority-del-" +
                                        deliverable.id,
                                      attrs: { title: "Priority" },
                                      on: {
                                        click: function($event) {
                                          return _vm.setPriority(
                                            deliverable,
                                            true
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("vue-star-rate", {
                                        key:
                                          "del-rating-" +
                                          Math.random() +
                                          deliverable.id,
                                        attrs: {
                                          rateRange: deliverable.priority
                                            ? Number(deliverable.priority)
                                            : 0,
                                          maxIcon: 5,
                                          iconHeight: 17,
                                          iconWidth: 17,
                                          hasCounter: false,
                                          iconColor: "#4C9850",
                                          iconColorHover: "#4C9850",
                                          iconShape: "circle"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showAltStartEndDate(deliverable)
                            ? [
                                _vm._l(
                                  _vm._.filter(deliverable.customFields, {
                                    field_key: "start_date"
                                  }),
                                  function(field, index) {
                                    return _c(
                                      "div",
                                      {
                                        key: index,
                                        staticClass:
                                          "data-items deliverable-start"
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "text-primary" },
                                          [_vm._v("START DATE:")]
                                        ),
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t" +
                                            _vm._s(
                                              _vm._f("moment")(
                                                field.value,
                                                "DD MMM, YYYY"
                                              )
                                            ) +
                                            "\n\t\t\t\t\t\t\t\t"
                                        )
                                      ]
                                    )
                                  }
                                ),
                                _vm._v(" "),
                                _vm._.filter(deliverable.customFields, {
                                  field_key: "start_date"
                                }).length == 0
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "data-items deliverable-start"
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "text-primary" },
                                          [_vm._v("START DATE:")]
                                        ),
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\tNo Date\n\t\t\t\t\t\t\t"
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "data-items deliverable-end" },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "text-primary" },
                                      [_vm._v("END DATE:")]
                                    ),
                                    _vm._v(" "),
                                    _vm.calculateEndDate(deliverable)
                                      ? [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t" +
                                              _vm._s(
                                                _vm._f("moment")(
                                                  _vm.calculateEndDate(
                                                    deliverable
                                                  ),
                                                  "DD MMM, YYYY"
                                                )
                                              ) +
                                              "\n\t\t\t\t\t\t\t\t"
                                          )
                                        ]
                                      : [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\tNo Date\n\t\t\t\t\t\t\t\t"
                                          )
                                        ]
                                  ],
                                  2
                                )
                              ]
                            : [
                                _c(
                                  "div",
                                  {
                                    staticClass: "data-items deliverable-start"
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "text-primary" },
                                      [_vm._v("STARTED:")]
                                    ),
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm._f("moment")(
                                            deliverable.created_at,
                                            "DD MMM, YYYY @ H:mm"
                                          )
                                        ) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                deliverable.all_completed
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "data-items deliverable-completed"
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "text-primary" },
                                          [_vm._v("COMPLETED:")]
                                        ),
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t" +
                                            _vm._s(
                                              _vm._f("moment")(
                                                deliverable.completed_at,
                                                "DD MMM, YYYY @ H:mm"
                                              )
                                            ) +
                                            "\n\t\t\t\t\t\t\t"
                                        )
                                      ]
                                    )
                                  : _c(
                                      "div",
                                      {
                                        staticClass:
                                          "data-items deliverable-last-mod"
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "text-primary" },
                                          [_vm._v("LAST MODIFIED:")]
                                        ),
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t" +
                                            _vm._s(
                                              _vm._f("moment")(
                                                deliverable.updated_at,
                                                "DD MMM, YYYY @ H:mm"
                                              )
                                            ) +
                                            "\n\t\t\t\t\t\t\t"
                                        )
                                      ]
                                    )
                              ],
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "data-items no-padding deliverable-tags"
                            },
                            [
                              _c("DeliverableListTags", {
                                staticClass: "deliverable-list-tags",
                                attrs: { deliverable: deliverable }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "data-items deliverable-project" },
                            [
                              _c("DeliverableProjects", {
                                attrs: { deliverable: deliverable }
                              })
                            ],
                            1
                          )
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "row listing-row" }, [
                        _c(
                          "div",
                          {
                            staticClass: "col-md-8 titles breakpoint__fix",
                            style: _vm.infoColStyle(deliverable)
                          },
                          [
                            _vm.showDepartment(deliverable)
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "inside-list department--wrap--new"
                                  },
                                  [
                                    _c("DeliverableDepartments", {
                                      attrs: { deliverable: deliverable }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "deliverable-title edit-d-title",
                                on: {
                                  click: function($event) {
                                    return _vm.showModalFn(deliverable.id)
                                  }
                                }
                              },
                              [
                                _vm.userCanEditDeliverable(deliverable)
                                  ? _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "b-tooltip",
                                            rawName: "v-b-tooltip.hover",
                                            modifiers: { hover: true }
                                          }
                                        ],
                                        staticClass: "option-bar",
                                        attrs: { title: "Remove from project" },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.$root.$emit(
                                              "showRemoveDeliverableFromProjModal",
                                              deliverable.id
                                            )
                                          }
                                        }
                                      },
                                      [_vm._m(1, true)]
                                    )
                                  : _vm._e(),
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(deliverable.title) +
                                    "\n                            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "mobile-task-expand-button-area" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "mobile-task-exp-btn" },
                                  [
                                    _c("CollapseTaskBtn", {
                                      attrs: {
                                        deliverable: deliverable,
                                        index: index,
                                        expandAll: _vm.expandAll
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        !_vm.isMobile()
                          ? _c("div", { staticClass: "col-md-4 infos" }, [
                              _c(
                                "div",
                                { staticClass: "d-flex flex-row" },
                                [
                                  _vm.showInfoCol(deliverable)
                                    ? _c("DeliverableListCoordinators", {
                                        staticClass:
                                          "deliverable-list-coordinators",
                                        attrs: { deliverable: deliverable }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.showInfoCol(deliverable)
                                    ? _c("DeliverableListContacts", {
                                        staticClass:
                                          "deliverable-list-contacts",
                                        attrs: { deliverable: deliverable }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("DeliverableListTags", {
                                    staticClass: "deliverable-list-tags",
                                    attrs: { deliverable: deliverable }
                                  }),
                                  _vm._v(" "),
                                  _c("DeliverableStatusOverview", {
                                    attrs: { deliverable: deliverable }
                                  })
                                ],
                                1
                              )
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-md-12" }, [
                          _c(
                            "div",
                            [
                              _c(
                                "b-collapse",
                                {
                                  attrs: {
                                    visible: _vm.expandAll,
                                    id: "task-listing-collapse-" + index
                                  },
                                  on: {
                                    shown: function($event) {
                                      return _vm.scrollToTaskAfterExpand(
                                        deliverable.tasks
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm.isMobile()
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-md-6 infos responsive-infos"
                                        },
                                        [
                                          _c("div", {
                                            staticClass: "d-flex flex-row"
                                          })
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("TaskFieldLabels", {
                                    attrs: {
                                      fullDeliverables: _vm.projectDeliverables,
                                      tasks: deliverable.tasks,
                                      deliverableId: deliverable.id,
                                      deliverable: deliverable
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("TaskFields", {
                                    attrs: {
                                      fullDeliverables: _vm.projectDeliverables,
                                      deliverable: deliverable,
                                      deliverableId: deliverable.id,
                                      myWeek: false,
                                      tasks: deliverable.tasks,
                                      users: deliverable.users
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ])
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "dbox-right-side dright-inner-wrap" },
                    [
                      _c("CollapseTaskBtn", {
                        attrs: {
                          deliverable: deliverable,
                          expandAll: _vm.expandAll,
                          index: index
                        }
                      })
                    ],
                    1
                  )
                ])
              ],
              1
            )
          ]
        )
      }),
      _vm._v(" "),
      _vm.projectDeliverables.length == 0
        ? _c("div", [
            _vm._v(
              "\n            Project has no deliverables assigned to it yet.\n        "
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-wrapper" },
        [
          _c("pagination", {
            attrs: { data: _vm.allProjectDeliverablesPaginationData, limit: 5 },
            on: { "pagination-change-page": _vm.onChangePage }
          })
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "data-items hide-mobile" }, [
      _c("span", {}, [_vm._v("END DATE:")]),
      _vm._v("\n\t\t\t\t\t\t\t\tNo Date\n\t\t\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("i", { staticClass: "fas fa-trash" })])
  }
]
render._withStripped = true

export { render, staticRenderFns }